import axios from 'axios';

import loginModule from '../../store/login/loginModule';
axios.defaults.transformRequest = function(data: any) {
    return data;
};
let instance = axios.create({
    baseURL: `/apinew`,
    timeout: 60000,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Access-Control-Allow-Headers': '*',
    },
});

instance.interceptors.request.use(
    config => {
        let UserToken = localStorage.getItem('UserToken');
        let UserID = localStorage.getItem('UserID');
        let authToken = window.btoa(UserID + ':' + UserToken);
        config.headers['Authorization'] = authToken;
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

export default instance;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/services/axios/tmsServiceToFormData.ts